import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Customization of the Typer",
description: "Learn how to customize Freon’s typer per concept by extending or overriding generated methods in your custom Typer implementation.",
tags: [ "typer", "customization", "Freon", "type provider", "FreTyper", "DSL development", "TypeScript"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};